import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';
// import styleReducer  from './slices/styleSlice';

const store = configureStore({
  reducer: rootReducer,
});

export default store;
